const MIN_DIMENSIONS = {
  smaller: 180,
  larger: 320
};

export const validateDimensions = (file, action) => {
  const fileReader = new FileReader();
  fileReader.readAsDataURL(file);
  const img = new Image();

  return new Promise((resolve, reject) => {
    fileReader.addEventListener('load', () => {
      img.src = fileReader.result;
      img.addEventListener('load', () => {
        const width = img.width;
        const height = img.height;
        const minDimension = Math.min(width, height);
        const maxDimension = Math.max(width, height);

        if (action === 'banner') {
          if (width === 300 && height === 250) {
            return resolve();
          } else {
            return reject('Banner image must be 300x250');
          }
        } else {
          if (
            minDimension >= MIN_DIMENSIONS.smaller &&
            maxDimension >= MIN_DIMENSIONS.larger
          ) {
            return resolve();
          } else {
            return reject(
              `Image size must be at least ${MIN_DIMENSIONS.smaller}x${MIN_DIMENSIONS.larger} or ${MIN_DIMENSIONS.larger}x${MIN_DIMENSIONS.smaller}`
            );
          }
        }
      });
      img.addEventListener('error', () => {
        return reject('Error loading image');
      });
    });

    fileReader.addEventListener('error', () => {
      return reject('Error reading file');
    });
  });
};
